import React from "react";
import StatusIcons from "../../../../../../../Components/StatusIcons/StatusIcons";
import { marketplaceOf } from "./marketplaces";

/**
 * Status column: the order status chip, as before; underneath, the
 * marketplace's own status in its status colour ("Shopify: Processing")
 * when there is one.
 */
const StatusCell = ({ row }) => {
  const marketStatus = String(row?.market_place_status ?? "").trim();
  const marketplace = marketplaceOf(row)?.label ?? "Marketplace";

  return (
    <div className="flex w-full min-w-0 flex-col items-start gap-[2px]">
      <div className="flex min-w-0 max-w-full">
        <StatusIcons status={row?.status} />
      </div>
      {marketStatus && (
        <div
          title={`Status on ${marketplace}`}
          className="flex min-w-0 max-w-full items-center overflow-hidden font-normal text-ui-text-subtle"
        >
          <span className="shrink-0">{marketplace}:</span>
          {/* The badge's own 3px vertical padding is taken back so the
              line keeps the height of plain text; overflow-hidden above
              clips that empty padding, or the table cell would scroll. */}
          <span className="-my-[3px] flex min-w-0">
            <StatusIcons status={marketStatus} noBg={true} noDot={true} />
          </span>
        </div>
      )}
    </div>
  );
};

export default StatusCell;
